module.exports = __webpack_public_path__ + "img/ls2.b73ee3e7.jpg";